import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountBlockedResult, AccountPagedResult, CheckRemovalAccountResult, GetRemovalAccount, GetRemovalAccountResult, GetRemovalsAccountResult } from '../model/account.model';
import { AccountServiceRest } from './account.service-rest';

@Injectable()
export class AccountService {
  constructor(private serviceRest: AccountServiceRest) { }

  getAccounts(page: number, pageSize: number, search: string, accountBlockedSelected: boolean, accountSuspectedFraudSelected: boolean, accountDeletedSelected: number): Observable<AccountPagedResult> {
    return this.serviceRest.getAccounts(page, pageSize, search, accountBlockedSelected, accountSuspectedFraudSelected, accountDeletedSelected);
  }

  checkRemovalAccount(): Observable<CheckRemovalAccountResult> {
    return this.serviceRest.checkRemovalAccount();
  }

  getRemovalAccountResult(accountId: string): Observable<GetRemovalsAccountResult> {
    return this.serviceRest.getRemovalAccountResult(accountId);
  }

  updateStatus(payload: GetRemovalAccount): Observable<GetRemovalAccountResult> {
    return this.serviceRest.updateStatus(payload);
  }

  putAccountBlocked(accountId: string, changeTo: boolean): Observable<AccountBlockedResult> {
    return this.serviceRest.putAccountBlocked(accountId, changeTo);
  }

  putDeviceBlocked(accountId: string, deviceId: string, changeTo: boolean): Observable<AccountBlockedResult> {
    return this.serviceRest.putDeviceBlocked(accountId, deviceId, changeTo);
  }
}
